import React from 'react'
import {
    AppDownloadSection,
    StyledAppDownloadSubTextBottom,
    StyledAppDownloadTitleBottom,
    InnerAppDownloadTextSectionBottom,
    AppDownloadContentSectionBottom
} from './TNAppDownloadSectionBottom.styled'

export function TNAppDownloadSectionBottom() {
    return (
        <AppDownloadSection>
            <AppDownloadContentSectionBottom>
                <InnerAppDownloadTextSectionBottom>
                    <StyledAppDownloadTitleBottom>
                        About the app
                    </StyledAppDownloadTitleBottom>
                    <StyledAppDownloadSubTextBottom>
                        The new free The Nightly app has been developed by the team at Seven West Media and is available on the App Store and Google Play.
                    </StyledAppDownloadSubTextBottom>
                </InnerAppDownloadTextSectionBottom>
            </AppDownloadContentSectionBottom>
        </AppDownloadSection>
    )
}
